import styled from '@emotion/styled';

import RenderLink from '../../UI/RenderLink/RenderLink';

const StyledWrapper = styled('div')(() => ({
    position: 'relative',
    overflow: 'hidden',
}));

const StyledLink = styled('a')(() => ({
    outline: 'none',
}));

const StyledRenderedLink = styled(RenderLink)(() => ({
    outline: 'none',
}));

export { StyledLink, StyledRenderedLink, StyledWrapper };
